import { Flex, Box } from "@chakra-ui/react";
import Nav from "../components/NavBar";
import Header from "../components/Hero";
import About from "../components/About";
import Studies from "../components/Studies";
import Skills from "../components/Skills";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Certifications from "../components/Certifications";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

// Components read the current language from LanguageContext (see index.js),
// so no language props are threaded here.
export default function PublicCv() {
  return (
    // Full-height column so the footer always sits at the bottom (no canvas gap).
    // Extra bottom padding on mobile leaves room for the floating tab bar.
    <Flex direction="column" minH="100vh" pb={{ base: "88px", md: 0 }}>
      <Nav />
      <Box flex="1">
        <Header />
        <About />
        <Studies />
        <Skills />
        <Experience />
        <Projects />
        <Certifications />
        <Contact />
      </Box>
      <Footer />
    </Flex>
  );
}
